import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'

import { PageContainer } from '@/components/ui/page-container'
import { useCreateDocument } from '@/hooks/use-documents'
import { documentsUrlWithDocument } from './documents-shared'

/** Creates a blank document and opens it on the list page canvas. */
export function DocumentNewPage() {
  const navigate = useNavigate()
  const createDocument = useCreateDocument()
  const startedRef = useRef(false)

  useEffect(() => {
    if (startedRef.current) return
    startedRef.current = true
    void createDocument.mutateAsync().then((created) => {
      navigate(documentsUrlWithDocument(created.id), { replace: true })
    })
  }, [createDocument, navigate])

  return (
    <PageContainer>
      <div className="flex items-center gap-2 py-12 text-sm text-muted-foreground">
        <Loader2 className="size-4 animate-spin" />
        Creating document…
      </div>
    </PageContainer>
  )
}
